import apiClient from '@services/api/apiClient.jsx';

/**
 * 테마 레이아웃 매핑 API 서비스
 */
const themeLayoutMappingApi = {
    /**
     * 테마별 레이아웃 매핑 목록 조회
     */
    getThemeLayoutMappings: async (themeId) => {
        try {
            const response = await apiClient.get(`/theme-layout-mappings`, {
                params: { themeId }
            });
            return response.data.data;
        } catch (error) {
            console.error('테마 레이아웃 매핑 목록 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 특정 테마 레이아웃 매핑 조회
     */
    getThemeLayoutMapping: async (mappingId) => {
        try {
            const response = await apiClient.get(`/theme-layout-mappings/${mappingId}`);
            return response.data.data;
        } catch (error) {
            console.error('테마 레이아웃 매핑 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 추가 가능한 레이아웃 목록 조회
     */
    getAvailableLayouts: async (themeId) => {
        try {
            const response = await apiClient.get(`/theme-layout-mappings/available-layouts`, {
                params: { themeId }
            });
            return response.data.data;
        } catch (error) {
            console.error('사용 가능한 레이아웃 목록 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 테마에 레이아웃 추가
     */
    addLayoutToTheme: async (themeId, photoLayoutId, customImages = {}) => {
        try {
            const formData = new FormData();
            formData.append('themeId', themeId);
            formData.append('photoLayoutId', photoLayoutId);

            if (customImages.defaultImageResourceId) {
                formData.append('customDefaultImageResourceId', customImages.defaultImageResourceId);
            }
            if (customImages.hoverImageResourceId) {
                formData.append('customHoverImageResourceId', customImages.hoverImageResourceId);
            }
            if (customImages.displayOrder) {
                formData.append('displayOrder', customImages.displayOrder);
            }

            const response = await apiClient.post(`/theme-layout-mappings`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data.data;
        } catch (error) {
            console.error('테마에 레이아웃 추가 실패:', error);
            throw error;
        }
    },

    /**
     * 테마 레이아웃 매핑 수정
     */
    updateThemeLayoutMapping: async (mappingId, updateData) => {
        try {
            const formData = new FormData();

            if (updateData.customDefaultImageResourceId !== undefined) {
                formData.append('customDefaultImageResourceId', updateData.customDefaultImageResourceId || '');
            }
            if (updateData.customHoverImageResourceId !== undefined) {
                formData.append('customHoverImageResourceId', updateData.customHoverImageResourceId || '');
            }
            if (updateData.isActive !== undefined) {
                formData.append('isActive', updateData.isActive);
            }

            const response = await apiClient.put(`/theme-layout-mappings/${mappingId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data.data;
        } catch (error) {
            console.error('테마 레이아웃 매핑 수정 실패:', error);
            throw error;
        }
    },

    /**
     * 테마에서 레이아웃 제거
     */
    removeLayoutFromTheme: async (mappingId) => {
        try {
            const response = await apiClient.delete(`/theme-layout-mappings/${mappingId}`);
            return response.data.success;
        } catch (error) {
            console.error('테마에서 레이아웃 제거 실패:', error);
            throw error;
        }
    },

    /**
     * 레이아웃 순서 변경
     */
    reorderLayouts: async (themeId, mappingOrders) => {
        try {
            const requestData = {
                themeId,
                mappingOrders
            };

            const response = await apiClient.put(`/theme-layout-mappings/reorder`, requestData);
            return response.data.success;
        } catch (error) {
            console.error('레이아웃 순서 변경 실패:', error);
            throw error;
        }
    },

    /**
     * 테마별 레이아웃 매핑 수 조회
     */
    getThemeLayoutMappingCount: async (themeId) => {
        try {
            const response = await apiClient.get(`/theme-layout-mappings/count`, {
                params: { themeId }
            });
            return response.data.data;
        } catch (error) {
            console.error('테마 레이아웃 매핑 수 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 레이아웃 중복 체크
     */
    checkLayoutDuplicate: async (themeId, photoLayoutId) => {
        try {
            const response = await apiClient.get(`/theme-layout-mappings/check-duplicate`, {
                params: { themeId, photoLayoutId }
            });
            return response.data.data; // true: 사용 가능, false: 중복
        } catch (error) {
            console.error('레이아웃 중복 체크 실패:', error);
            throw error;
        }
    }
};

export default themeLayoutMappingApi;
